var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if( isLoaded ){ 
__p+='\n  ';
 if (model.type == 'image' || model.type == 'video') { 
__p+='\n    <a href="'+
((__t=( model.source ))==null?'':_.escape(__t))+
'" class="popup qa-thumb-attach ';
 if(model.type == 'video'){ 
__p+='mfp-iframe';
 }else{ 
__p+='mfp-image';
 } 
__p+='" data-mfp-type=""><img src="'+
((__t=( model.source_thumb ))==null?'':_.escape(__t))+
'" class="add-attachment__screenshot" alt="title" /></a>\n    <button type="button" class="btn--secondary add-attachment__place-link js-bbcode qa-button-attach-place-in-text" data-bbcode="';
 if(model.type == 'image'){ 
__p+='img';
 }else{ 
__p+='video';
 } 
__p+='" data-rel="'+
((__t=( model.bbcode_url ))==null?'':_.escape(__t))+
'">\n      '+
((__t=( labels.place ))==null?'':_.escape(__t))+
'\n    </button>\n    <div class="add-attachment__show">\n        <input id="attachment__show_'+
((__t=( model.__id ))==null?'':_.escape(__t))+
'" type="checkbox" ';
 if(isAttachment){ 
__p+=' checked="checked" ';
 } 
__p+=' class="switch__checkbox js-check" value="true" />\n        <label class="switch__label" for="attachment__show_'+
((__t=( model.__id ))==null?'':_.escape(__t))+
'">\n          <span>'+
((__t=( labels.attachment ))==null?'':_.escape(__t))+
'</span>\n            <div class="switch__inner">\n              <span class="switch__switch qa-switch-attach-show"></span>\n            </div>\n        </label>\n    </div>\n  ';
 } else { 
__p+='\n    <a href="'+
((__t=( model.source ))==null?'':_.escape(__t))+
'" class="file-attachment '+
((__t=( model.type ))==null?'':_.escape(__t))+
' qa-thumb-file-attachment" alt="'+
((__t=( model.file_original_name ))==null?'':_.escape(__t))+
'" target="_blank">'+
((__t=( model.file_original_name ))==null?'':_.escape(__t))+
'</a>\n  ';
 } 
__p+='\n  <button type="button" class="btn--cancel add-attachment__delete js-delete qa-button-attach-delete">\n    <i class="icon--cross icon--auto-width"></i>\n  </button>\n  <input class="input_attachment" type="hidden" name="'+
((__t=( input_name ))==null?'':_.escape(__t))+
'[]" value=\''+
((__t=( formData ))==null?'':_.escape(__t))+
'\' />\n';
 } else { 
__p+='\n<div class="loader"></div>\n';
 } 
__p+='\n';
}
return __p;
};
